import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-deep-charcoal border-t border-gray-800 py-6 md:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <div className="text-center md:text-left">
            <div className="text-xl md:text-2xl font-black mb-1 md:mb-2 tracking-tight">
              <span className="text-champagne-gold">WORLD</span>
              <span className="text-champagne-gold">TITLE</span>
              <span className="text-champagne-gold">FIGHT</span>
              <span className="text-champagne-gold">.COM</span>
            </div>
            <div className="text-gray-400 text-sm md:text-base font-light tracking-wide">
              Premium Combat Sports Domain
            </div>
          </div>
          
          <div className="text-center md:text-right">
            <div className="text-gray-400 text-sm mb-1 md:mb-2">
              For inquiries: <a href="mailto:info@domainaims.com" className="text-champagne-gold hover:text-yellow-300 transition-colors duration-300">info@domainaims.com</a>
            </div>
            <div className="text-gray-500 text-xs md:text-sm">
              © 2026 domainaims.com
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}